import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { inject } from "@angular/core";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { SnackbarService } from "../services/snackbar.service";
import { parseError } from "../utils/common";
import { ApiService } from "../services/api.service";
import { CoreService } from "../services/core.service";

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const redirectionFilter = ["logout", "user_login_v2"];
  const errorFilter = ["login.html", "/service_config/maintenance", "landing.html", "register.html", "footer.html", "/bf/market_status", "/bf/markets"];
  const snackbar = inject(SnackbarService);
  const apiService = inject(ApiService);
  const coreService = inject(CoreService);
  const isLogin = req.url.includes("/auth/user_login");
  const shouldIgnoreError = errorFilter.some((segment) => req.url.includes(segment));
  const shouldIgnoreRedirection = redirectionFilter.some((segment) => req.url.includes(segment));
  const genericErrorMsg = "An unexpected error occurred. Please contact administrator for further support.";
  const router = inject(Router);
  const isRouteLogin = router.url.includes("/login");

  if (shouldIgnoreError) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if ((err.status >= 500 && err.status < 600) || err.error instanceof ProgressEvent || err.status === 0) {
          snackbar.openSnackbar({ message: "Disconnected: Please refresh the page" });
        } else if (err.status === 401 && err?.error?.hasOwnProperty("error")) {
          const error = err?.error?.error;
          const isMaintenanceMode = error?.includes("DETAIL: E0001");
          snackbar.openSnackbar({ message: parseError(error) || genericErrorMsg });
          if (isMaintenanceMode) coreService.redirectToMaintenance();
        } else if ([401, 403].includes(err.status) && !shouldIgnoreRedirection && !isRouteLogin) {
          apiService.handleSignOut();
        } else {
          console.error(genericErrorMsg);
          snackbar.openSnackbar({ message: parseError(err?.error?.error) || genericErrorMsg });
        }
      } else {
        snackbar.openSnackbar({ message: genericErrorMsg });
        console.error(genericErrorMsg);
      }

      return throwError(() => err);
    }),
  );
};
